// extracted by mini-css-extract-plugin
export default {"marquee-wrap":"AKVD3","marquee":"eR8w2"};